import * as actionTypes from '../../constants/actionTypes';
import { ASCENDING_ORDER } from '../../constants/users';

const initialState = {
  search: '',
  isLoading: false,
  error: undefined,
  filter: {},
  sortBy: { column: 'title', order: ASCENDING_ORDER.toLowerCase() },
  pagination: {
    page: 1,
    itemsAmount: 10,
  },
};

const facilities = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FACILITY_SEARCH:
      return { ...state, search: action.payload.search, pagination: initialState.pagination };
    case actionTypes.SET_FACILITY_SORT_BY:
      return { ...state, sortBy: action.payload.sortBy, pagination: initialState.pagination };
    case actionTypes.SET_FACILITY_PAGINATION:
      return { ...state, pagination: action.payload.pagination };
    case actionTypes.SET_FACILITY_PARTNER_ID:
      return {
        ...state,
        filter: { ...state.filter, partnerId: action.payload.filter.partnerId },
        pagination: initialState.pagination,
      };
    case actionTypes.SET_FACILITY_USER_ID:
      return {
        ...state,
        filter: { ...state.filter, userId: action.payload.filter.userId },
        pagination: initialState.pagination,
      };
    case actionTypes.SET_FACILITY_CONTACT_ID:
      return {
        ...state,
        filter: { ...state.filter, contactId: action.payload.filter.contactId },
        pagination: initialState.pagination,
      };
    case actionTypes.CLEAR_FACILITY_FILTERS:
      return { ...state, filter: null, pagination: initialState.pagination };
    case actionTypes.DELETE_FACILITY_IN_PROGRESS:
      return { ...state, isLoading: action.payload.isLoading };
    case actionTypes.DELETE_FACILITY_ERROR:
      return { ...state, error: action.payload.error };
    case actionTypes.DELETE_FACILITY_SUCCEED:
    case actionTypes.AUTH_SIGN_OUT:
      return initialState;
    default:
      return state;
  }
};

export default facilities;
